import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  standalone: true,
  selector: 'base-empty-state-input',
  templateUrl: './empty-state-input.component.html',
  styleUrls: ['./empty-state-input.component.scss'],
  imports: [CommonModule, RouterModule]
})
export class EmptyStateInputComponent {
  private router = inject(Router);


  search(query: string) {
    this.router.navigate([`/search`], { queryParams: { q: query } })
  }

}

